import React, { Component } from 'react';
import { Form, Button, Card, Col, Row } from 'react-bootstrap';
import axios from 'axios'
import { connect } from 'react-redux';
import {setUser} from '../actions/userActions'
import PrivacyPolicy from '../components/privacyPolicy'
class CreateAccount extends Component {
    state = { 
        email: '',
        password: '',
        errorString: '',
        confirmEmail: '',
        emailValid: false,
        emailSame: false,
        passwordValid: false,
        passwordSame: false,
        confirmPassword: '',
        showPolicy: false,
        policy: false,
        policyInvalid: false,
        marketingPreferences: {email: false, phone: false, text: false}
     }
     componentDidMount(){
        // axios.post('https://hosting.breezelabs.co.uk/api/stats/page-visit', {referer: document.referrer ? document.referrer : 'searchbar', site: 'CNCBreeze - create-account'})
    }
    handleForm = () => {
        var user = {
            email: this.state.email, 
            password: this.state.password,
            marketingPreferences: this.state.marketingPreferences,
        }
        let {valid, invalid} = this.validateAll()
        if(valid){
            axios.post('/api/user/create', user).then(res=>{
                if(res.data.success){

                    this.props.setUser({user: res.data.user, token: res.data.token})
                }else{
                    this.setState({errorString: res.data.error})
                }
            })
        }else{
            this.setState({policyInvalid: invalid.policyInvalid,passwordSame: invalid.passwordSame, passwordValid: invalid.passwordValid, emailValid: invalid.emailValid, emailSame: invalid.emailSame})
        }
    }
    validateAll=()=>{
        let valid = true
        let invalid = {}
        let emailValidity = this.validateEmailOnly()
        let passwordValidity = this.validatePasswordOnly()
        valid = emailValidity.valid && passwordValidity.valid && this.state.policy
        invalid = {policyInvalid: !this.state.policy,...passwordValidity.invalid, ...emailValidity.invalid }
        return {valid: valid, invalid: invalid}
    }
    validateEmailOnly=()=>{
        let valid = true
        let invalid={}
        if(!this.validateEmail(this.state.email)){
            valid = false
            invalid.emailValid = true
        }else{
            invalid.emailValid = false
        }
        if(this.state.email !== this.state.confirmEmail){
            valid = false
            invalid.emailSame = true
        }else{
            invalid.emailSame = false
        }
        return {valid: valid, invalid: invalid}
    }
    validatePasswordOnly = () => {
        let valid = true
        let invalid={}
        if(!this.validatePassword(this.state.password)){
            valid = false
            invalid.passwordValid = true
        }else{
            invalid.passwordValid = false
        }
        if(this.state.password !== this.state.confirmPassword){
            valid = false
            invalid.passwordSame = true
        }else{
            invalid.passwordSame = false
        }
        return {valid: valid, invalid: invalid}
    }
    handleChange = (e, type) =>{
        this.setState({[type]: e.target.value},async()=>{
            let validity
            if(type === 'email' || type === 'confirmEmail'){
                validity =  await  this.validateEmailOnly()
            }
            if(type === 'password' || type === 'confirmPassword'){
                validity = await this.validatePasswordOnly()
            }
            this.setState({...validity.invalid})

        })
    }
    validatePassword = (password) => {
        const re = /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
        return re.test(String(password));
    }
    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
     }
     closePolicy=()=>{
         this.setState({showPolicy: false})
     }
     openPolicy=()=>{
        this.setState({showPolicy: true})
    }
    handlePolicy=()=>{
        this.setState({policy: !this.state.policy})
    }
    handleMarketing=(type)=>{
        let marketingPreferences = this.state.marketingPreferences
        marketingPreferences[type] = !marketingPreferences[type]
        this.setState({marketingPreferences: marketingPreferences})
    }
    render() { 
                let darkmode = this.props.user ? this.props.user.darkmode : true

        return ( 
            
            <div style={{width: '100%', marginTop: '60px', paddingBottom: '60px'}}>
            <Card style={{width: '80%',margin: 'auto'}}>
                <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{textAlign: 'center'}}>
                    <h1>Create Account</h1>
                </Card.Header>
                <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{textAlign: 'center'}}>
                {this.state.emailValid && 
                        <Row >
                            <Col>
                            <p>Email not valid</p>
                            </Col>
                        </Row>
                    }
                    <Row style={{padding: '20px'}}>
                        <Col xs={4}>
                        <label>Email</label>
                        </Col>
                        <Col xs={6}>
                            <Form.Control onChange={(e)=>this.handleChange(e,'email')} type="text" placeholder="Enter Email" />
                        </Col>
                        
                    </Row>
                    {this.state.emailSame && 
                        <Row >
                            <Col>
                            <p>Emails are not the same</p>
                            </Col>
                        </Row>
                    }
                    <Row style={{padding: '20px'}}>
                        <Col xs={4}>
                        <label>Confirm Email</label>
                        </Col>
                        <Col xs={6}>
                            <Form.Control onChange={(e)=>this.handleChange(e,'confirmEmail')} type="text" placeholder="Confirm Email" />
                        </Col>
                        
                    </Row>
                    {this.state.passwordValid && 
                        <Row >
                            <Col>
                            <p>Password not valid</p>
                            </Col>
                        </Row>
                    }
                    <Row style={{padding: '20px'}}>
                        <Col xs={4}>
                            <label>Password (must contain at least one uppercase, lowercase, number, and special character, and be 8 characters min)</label>

                        </Col>
                        <Col xs={6}>
                        <Form.Control onChange={(e)=>this.handleChange(e,'password')} type="password" placeholder="Enter Password" />

                        </Col>
                        
                    </Row>
                    {this.state.passwordSame && 
                        <Row >
                            <Col>
                            <p>Passwords not the same</p>
                            </Col>
                        </Row>
                    }
                    <Row style={{padding: '20px'}}>
                        <Col xs={4}>
                            <label>Confirm Password</label>

                        </Col>
                        <Col xs={6}>
                        <Form.Control onChange={(e)=>this.handleChange(e,'confirmPassword')} type="password" placeholder="Confirm Password" />

                        </Col>
                        
                    </Row>
                    
                    <Row style={{padding: '20px'}}>
                        <p>From time to time we would like to contact you with details of other products, offers, services and competitions we provide. If you consent to us contacting you for this purpose please tick to say how you would like us to contact you. You can change this at any time in your account settings.</p>
                    </Row>
                    <Row style={{padding: '20px'}}>
                        <Col style={{textAlign: 'center'}} xs={4}>
                            <p>Email</p>
                            <Form.Control onClick={()=>this.handleMarketing('email')} type="checkbox"/>
                        </Col>
                        <Col xs={4}>
                            <p>Phone</p>
                            <Form.Control onClick={()=>this.handleMarketing('phone')} type="checkbox"/>
                        </Col>
                        <Col xs={4}>
                            <p>Text</p>
                            <Form.Control onClick={()=>this.handleMarketing('text')} type="checkbox"/>
                        </Col>
                        
                    </Row>
                    <Row><br/></Row>
                    {this.state.policyInvalid && 
                        <Row >
                            <Col>
                            <p>You must accept our privacy policy</p>
                            </Col>
                        </Row>
                    }
                    <Row style={{padding: '20px'}}>
                        <Col xs={5}>
                            <label>I accept <a onClick={this.openPolicy}><p style={{color: 'blue'}} >BreezeLab's Privacy Policy</p></a></label>
                        </Col>
                        <Col xs={2}>
                        <Form.Control onClick={this.handlePolicy} type="checkbox"/>

                        </Col>
                        
                    </Row>
                    
                </Card.Body>
                <Card.Footer className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} >
                    <div style={{textAlign: 'center'}}>
                    {this.state.errorString}
                    <Button onClick={this.handleForm} >Create account</Button>
                    </div>
                    
                </Card.Footer>
            </Card>     
                 <PrivacyPolicy showPolicy={this.state.showPolicy} closePolicy={this.closePolicy} openPolicy={this.openPolicy}/>      
        </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch){
    return{
        setUser: (data)=>{dispatch(setUser(data))}
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount);
